// Closed-hole / dichtgemaakte-gaten logica voor karren-paalindeling.
//
// Regel:
// - Planten mogen wél over een dicht gat heen staan (gap-telling onveranderd).
// - Een PLAAT mag NIET in een dicht gat liggen. Valt een plaat op gat 1, 2, 3
//   of 34, dan schuift die plaat én alles erboven 1 gat omhoog.
// - Herhaal tot stabiel (een verschoven plaat kan op een ander dicht gat
//   belanden, of een hogere plaat kan door het meeschuiven nu op 34 vallen).
// - Bovenste plaat boven max (35 of 42) → laag valt weg in backend; in de UI
//   wordt het gemarkeerd zodat de gebruiker het ziet.

export const CLOSED_HOLES_DEFAULT = new Set([1, 2, 3, 34]);

/**
 * Korte plant-aanduiding zoals "Lav. ang. Hidcote".
 * - Woorden van 4 letters of korter blijven heel (bv. "Rosa", "Hebe").
 * - Langere woorden krijgen de eerste 3 letters + ".".
 * - Cultivar (indien aanwezig) wordt achter de afkorting geplakt, ongewijzigd.
 */
export function abbreviateLabel(name, cultivar) {
    const ab = (name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((w) => (w.length <= 4 ? w : `${w.slice(0, 3)}.`))
        .join(" ");
    const c = (cultivar || "").trim();
    return c ? `${ab} ${c}`.trim() : ab;
}

export function maxPositionFor(risers) {
    return 35 + (risers ? 7 : 0);
}

/**
 * Bereken plaatposities voor een paal.
 * @param {Array<number>} gaps - gap_units per laag (van onder naar boven).
 *                               gaps[0] is de gap onder de onderste laag.
 * @param {Object} options
 * @param {Set<number>} [options.closedHoles] - dichte gaten (default {1,2,3,34}).
 * @returns {Array<number>} posities (lengte = gaps.length).
 *                          positions[i] is de positie van de plaat boven laag i.
 *                          De onderste laag (i=0) heeft géén plaat — positions[0]
 *                          is de plaat onder laag 2.
 */
export function computeShiftedPlatePositions(gaps, options = {}) {
    const closed = options.closedHoles || CLOSED_HOLES_DEFAULT;
    if (!gaps || gaps.length === 0) return [];
    const pos = [];
    let running = 0;
    for (const g of gaps) {
        const step = (Number.isInteger(g) && g > 0 ? g : 0) + 1;
        running += step;
        pos.push(running);
    }
    let changed = true;
    while (changed) {
        changed = false;
        for (let i = 0; i < pos.length; i++) {
            while (closed.has(pos[i])) {
                for (let j = i; j < pos.length; j++) pos[j] += 1;
                changed = true;
            }
        }
    }
    return pos;
}
